import $ from 'jquery';
import 'smartmenus';
import 'smartmenus-keyboard';
import 'smartmenus-bootstrap-4';
import configureSearch from './frontend/search';
import keyboardNav from './frontend/keyboardNav';
import '../scss/index.scss';

document.addEventListener('DOMContentLoaded', () => {
  // Set up the search
  configureSearch();

  keyboardNav();

  // Breadcrumb modifications
  const $breadcrumbLinks = $('.breadcrumbs a');
  $breadcrumbLinks.last().removeAttr('href').css('text-decoration', 'none');
  $breadcrumbLinks.first().html('<i class="fas fa-home"></i> <span class="sr-only">Home Icon</span>');
}, false);

//mobile nav/seach open and close classes on body
(function ($) {
    var $body = $('body');
    var $nav = $('#mobile-nav');

    $('.mobile-nav-trigger').click(function (e) {
        e.preventDefault();
        $body.removeClass('mobile-search-open');
        if ($body.hasClass('mobile-nav-open')) {
            $body.removeClass('mobile-nav-open');
            setTimeout(function () {
                //$body.css('overflow', '');
                $body.removeClass('mobile-overflow-hidden');
                $nav[0].scrollTop = 0;
            }, 200); //wait for css transition of menu
        } else {
            //$body.css('overflow', 'hidden');
            $body.addClass('mobile-overflow-hidden');
            $body.addClass('mobile-nav-open');
        }
    });

    $('#mobile-search-trigger').click(function (e) {
        e.preventDefault();
        $body.removeClass('mobile-nav-open');
        if ($body.hasClass('mobile-search-open')) {
            $body.removeClass('mobile-search-open');
            setTimeout(function () {
                //$body.css('overflow', '');
                $body.removeClass('mobile-overflow-hidden');
            }, 200); //wait for css transition of menu
        } else {
            $body.addClass('mobile-search-open');
            //$body.css('overflow', '');
            $body.removeClass('mobile-overflow-hidden');
        }
  });

})(jQuery);


//fun with iOS safari
// this is here to deal with well-documented viewport issues on mobile safari so we can position the mobile menu on the bottom
// basically just keeping track of the viewport via js and attaching css when needed

(function ($) {
    var $body = $('body');

    var style,
        min_inner_height = false,
        max_inner_height = false,
        saved_inner_height_diff = false,
        debounce_timer;

    var adjustCSS = function () {
        var win_inner_h = window.innerHeight;
        //console.log(window.innerHeight);
        if (!style) {
            style = document.createElement('style');
            style.appendChild(document.createTextNode(''));
            document.head.appendChild(style);
        }

        if (min_inner_height === false || win_inner_h < min_inner_height) {
            min_inner_height = win_inner_h;
        }
        if (max_inner_height === false || win_inner_h > max_inner_height) {
            max_inner_height = win_inner_h;
        }
        if (saved_inner_height_diff !== max_inner_height - min_inner_height) {
            saved_inner_height_diff = max_inner_height - min_inner_height;
            var i = style.sheet.cssRules.length - 1;
            while (i >= 0) {
                if ('deleteRule' in style.sheet) { style.sheet.deleteRule(i); }
                else if ('removeRule' in style.sheet) { style.sheet.removeRule(i); }
                i--;
            }
            style.sheet.insertRule('@media only screen and (orientation: landscape) { .safari-toolbars-shown.mobile-buttons-open #mobile-buttons, .safari-toolbars-shown.mobile-nav-open #mobile-buttons{ bottom: ' + saved_inner_height_diff + 'px; }');
            style.sheet.insertRule('@media only screen and (orientation: landscape) { .safari-toolbars-shown.mobile-search-open.mobile-buttons-open #mobile-search{ bottom: ' + (parseInt(saved_inner_height_diff) + 81) + 'px; }');

        }

        if (max_inner_height !== false && max_inner_height === win_inner_h) {
            $body.removeClass('safari-toolbars-shown');
        } else {
            $body.addClass('safari-toolbars-shown');
        }
    };

    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {

        window.addEventListener('orientationchange', function () {
            min_inner_height = false;
            max_inner_height = false;
            saved_inner_height_diff = false;
            setTimeout(adjustCSS, 200);
        });

        window.addEventListener('scroll', function (event) {
            if (debounce_timer)
                window.cancelAnimationFrame(debounce_timer);

            debounce_timer = window.requestAnimationFrame(function () {
                adjustCSS();
            });

        }, false);
    }

    
})(jQuery);

